import { useSetRecoilState } from "recoil";
import { useRecordContext } from "react-admin";
import { ListItemIcon, ListItemText, MenuItem } from "@mui/material";
import { Student } from "../providers/studentsProvider";
import { studentInPreTheoryExamWorkflowState } from "../misc/PreTheoryExamWorkflowDialog";
import { ExamIcon } from "../icons/ExamIcon";

export function OpenPreTheoryExamWorkflowDialogMenuItem({ closeMenu }: { closeMenu: () => void }) {
  const student = useRecordContext<Student>();
  const setStudentShownInDialog = useSetRecoilState(studentInPreTheoryExamWorkflowState);

  return (
    <MenuItem
      onClick={() => {
        closeMenu();
        setStudentShownInDialog(student);
      }}
    >
      <ListItemIcon>
        <ExamIcon />
      </ListItemIcon>
      <ListItemText>Bereit für Theorieprüfung</ListItemText>
    </MenuItem>
  );
}
